import { useState } from 'react';
import { hotHashtags } from '@/mocks/gossip';
import SectionHead from './Section';
import { TonePill } from './Section';

const filters = ['全部', '爆', '升', '新'];

export default function TagWall() {
  const [filter, setFilter] = useState('全部');
  const [focus, setFocus] = useState('h1');

  const list =
    filter === '全部'
      ? hotHashtags
      : hotHashtags.filter((t) => (filter === '稳' ? false : t.delta === filter) || (filter === '新' && t.delta === '新') || (filter === '爆' && t.delta === '爆') || (filter === '升' && t.delta === '升'));

  const top = hotHashtags[0];

  return (
    <section className="bg-paper-50 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <SectionHead
          kicker="话题热度墙 · TALKING WALL"
          title="正在爆炸的瓜"
          desc="实时热度不代表实锤，只代表大家此刻都在聊。点进每个话题，能看到原始证据帖与讨论走向。"
          link="#zone"
        />

        <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-1 rounded-full border border-paper-200 bg-paper-100 p-1">
            {filters.map((f) => (
              <TonePill key={f} active={filter === f} tone="flame" onClick={() => setFilter(f)}>
                {f}
              </TonePill>
            ))}
          </div>
          <span className="text-xs text-ink-500">
            <i className="ri-time-line mr-1 align-[-1px]" />
            每 30 秒刷新一次热度
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          {/* 主话题大卡 */}
          <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-flame-600 to-flame-800 p-6 text-paper-50 lg:row-span-2 lg:flex lg:flex-col lg:justify-between">
            <div className="pointer-events-none absolute -right-8 -top-8 h-40 w-40 rounded-full bg-gold-400/20 blur-2xl" />
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-ink-950/30 px-3 py-1 text-xs font-black">
                <i className="ri-fire-fill text-gold-300" />
                今日主战场
              </span>
              <h3 className="mt-5 font-display text-3xl font-black leading-snug">{top.tag}</h3>
              <p className="mt-3 text-sm leading-6 text-paper-100/90">
                87°C 高速升温中，24 小时内新增 3000+ 讨论帖。实锤材料已超过 23 条，正在按时间线整理成合集。
              </p>
            </div>
            <div className="mt-6 flex items-end gap-1.5">
              {[6, 9, 7, 12, 8, 15, 11, 18, 14, 20, 16, 24].map((h, i) => (
                <span key={i} className="flex-1 rounded-t bg-paper-50/80" style={{ height: `${h * 2}px` }} />
              ))}
            </div>
            <div className="mt-4 flex items-center justify-between border-t border-paper-50/20 pt-4 text-xs">
              <span>
                <b className="font-display text-xl text-gold-200">{top.hot}</b> 讨论
              </span>
              <a href="#latest" className="cursor-pointer font-bold text-gold-100 hover:underline">
                进入话题 →
              </a>
            </div>
          </div>

          {/* 话题清单 */}
          <div className="lg:col-span-2 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {list
              .filter((t) => t.id !== top.id)
              .map((t) => {
                const active = focus === t.id;
                return (
                  <button
                    key={t.id}
                    type="button"
                    onClick={() => setFocus(t.id)}
                    className={`group cursor-pointer rounded-xl border p-4 text-left transition-all ${
                      active
                        ? 'border-flame-500 bg-flame-50'
                        : 'border-paper-200 bg-paper-50 hover:border-gold-500 hover:bg-gold-50'
                    }`}
                  >
                    <div className="flex items-start justify-between gap-3">
                      <div className="min-w-0">
                        <p className={`truncate font-bold ${active ? 'text-flame-800' : 'text-ink-900'}`}>{t.tag}</p>
                        <p className="mt-1.5 text-xs text-ink-500">
                          <b className={active ? 'text-flame-600' : 'text-ink-700'}>{t.hot}</b> 讨论热度
                        </p>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <span
                          className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                            t.delta === '爆'
                              ? 'bg-flame-500 text-white'
                              : t.delta === '新'
                                ? 'bg-gold-500 text-ink-950'
                                : 'bg-paper-200 text-ink-700'
                          }`}
                        >
                          {t.delta}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3 flex h-6 items-end gap-1">
                      {t.spikes.map((h, i) => (
                        <span
                          key={i}
                          className={`flex-1 rounded-t ${
                            active ? 'bg-flame-400' : 'bg-paper-300 group-hover:bg-gold-300'
                          }`}
                          style={{ height: `${(h / 10) * 100}%` }}
                        />
                      ))}
                    </div>
                  </button>
                );
              })}
          </div>
        </div>
      </div>
    </section>
  );
}